module.exports = __webpack_public_path__ + "static/img/7.aa0cd623.png";